var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllinclusive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3335 2C8.3335 0.895431 9.22893 0 10.3335 0C11.4381 0 12.3335 0.895431 12.3335 2C12.3335 2.06684 12.3302 2.13292 12.3238 2.19808C16.8931 3.12087 20.3335 7.15866 20.3335 12H0.333496C0.333496 7.15866 3.77388 3.12087 8.34318 2.19808C8.33677 2.13292 8.3335 2.06684 8.3335 2ZM10.2264 9.69003C10.2923 9.65048 10.3747 9.65048 10.4406 9.69003L12.2026 10.7466C12.3606 10.8413 12.5547 10.6996 12.5126 10.5203L12.046 8.53306C12.0282 8.45743 12.054 8.37821 12.1129 8.32753L13.6656 6.99117C13.8056 6.8707 13.7312 6.64118 13.5472 6.62567L11.5005 6.45315C11.4236 6.44668 11.3566 6.39826 11.3263 6.3273L10.5251 4.44918C10.4531 4.2804 10.2139 4.2804 10.1419 4.44918L9.34065 6.3273C9.31038 6.39826 9.24339 6.44668 9.16652 6.45315L7.1198 6.62567C6.93578 6.64118 6.86143 6.8707 7.00139 6.99117L8.5541 8.32753C8.61298 8.37821 8.63877 8.45743 8.62101 8.53306L8.15438 10.5203C8.11229 10.6996 8.30641 10.8413 8.46434 10.7466L10.2264 9.69003Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.333496 15H2.91928L3.62639 15.7071C3.81393 15.8946 4.06828 16 4.3335 16H16.3335C16.5987 16 16.8531 15.8946 17.0406 15.7071L17.7477 15H20.3335V13H0.333496V15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllinclusive);
export default __webpack_public_path__ + "static/media/allinclusive.329dec2263e8f4cad0a947e09ae6d68f.svg";
export { ForwardRef as ReactComponent };